import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/home/Home'),
    meta: {
      telescope: 'zyxcx-page-firsthealthcategory',
      headerNavActive: 'health'
    }
  },

  {
    path: '/course/list',
    name: 'CourseList',
    component: () => import('@/pages/course/CourseList'),
    meta: {
      telescope: 'zyxcx-page-secondhealthcategory',
      headerNavActive: 'health'
    }
  },
  {
    path: '/course/detail',
    name: 'CourseDetail',
    component: () => import('@/pages/course/CourseDetail'),
    meta: {
      telescope: 'zyxcx-page-healthcategory-coursedetail',
      headerNavActive: 'health'
    }
  },
  {
    path: '/course/chapter',
    name: 'ChapterChapter',
    component: () => import('@/pages/course/ChapterDetail'),
    meta: {
      telescope: 'zyxcx-page-healthcategory-lessondetail',
      headerNavActive: 'health'
    }
  },

  {
    path: '/graphic/list',
    name: 'graphic-list',
    component: () => import('@/pages/graphic/GraphicList'),
    meta: {
      telescope: 'zyxcx-page-secondhealthcategory',
      headerNavActive: 'health'
    }
  },
  {
    path: '/graphic/article',
    name: 'article',
    component: () => import('@/pages/graphic/ArticleFrame'),
    meta: {
      headerNavActive: 'health'
    }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

export default router;
